<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>

            <!--              <el-form-item label="分红ID">-->
            <!--                  <el-input  v-model="queryForm.incomeId"></el-input>-->
            <!--              </el-form-item>-->
            <!--              <el-form-item label="发放ID">-->
            <!--                  <el-input  v-model="queryForm.sendId"></el-input>-->
            <!--              </el-form-item>-->
            <el-form-item label="用户">
                <!--                  <el-input  v-model="queryForm.userId"></el-input>-->
                <GridSelectU style="width: 177px;" title="选择用户" labelName="userName"
                             labelValue="id" :value="queryForm.userId" :limit='1' size='small' placeholder='请选择用户'
                             @getValue="getSearchValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                </GridSelectU>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getModelTeamIncomeUserRecordList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button
                        type="danger"
                        plain
                        size="small"
                        icon="el-icon-delete"
                        :disabled="multipleSelection.length <= 0"
                        @click="deleteModelTeamIncomeUserRecord(null)"
                    >删除</el-button>
                </div>

                <div class="icon-group">
                    <el-upload v-if="this.isImportDate"
                               class="upload-demo"
                               action="#"
                               :http-request="upload"
                               :show-file-list="true">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <span
                        title="搜索"
                        class="icon-box"
                        @click="search"
                    >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
                    <span
                        class="icon-box"
                        @click="refreshModelTeamIncomeUserRecordList"
                    >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data="modelTeamIncomeUserRecordList"
                row-key="id"
                border
                height="100%"
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                @selection-change="handleSelectionChange"
                size="small"
            >
                <el-table-column
                    align="center"
                    type="selection"
                    width="60"
                > </el-table-column>
                <!--      <el-table-column-->
                <!--        :show-overflow-tooltip="true"-->
                <!--        align="center"-->
                <!--        prop="incomeId"-->
                <!--        label="分红ID"-->
                <!--        width="180"-->
                <!--      > </el-table-column>-->
                <!--        <el-table-column-->
                <!--        :show-overflow-tooltip="true"-->
                <!--        align="center"-->
                <!--        prop="sendId"-->
                <!--        label="发放ID"-->
                <!--        width="180"-->
                <!--      > </el-table-column>-->
                <el-table-column align="center" prop="name" label="头像" width="100">
                    <template slot-scope="scop">
                        <el-image
                            @click='updateSrcList(scop.row.userHeader)'
                            style="width: 30px; height: 30px"
                            :src="scop.row.userHeader"
                            :preview-src-list="srcList"
                        > </el-image>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="userName" label="账号" width="150"> </el-table-column>
                <el-table-column align="center" prop="userMobile" label="手机" width="150"> </el-table-column>

                <el-table-column align="center" prop="userNickname" label="昵称" width="150"> </el-table-column>
                <el-table-column align="center" prop="gradeName" label="等级" width="150">
                    <template slot-scope="scop">
                        <div>{{ scop.row.mppGrade.gradeName }}</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="状态" width="100">
                    <template slot-scope="scop">
                        <el-tag type="success" effect="light" v-if="scop.row.status == 1">正常</el-tag>
                        <el-tag type="danger" effect="light" v-if="scop.row.status == 0">禁用</el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="createTime" label="创建时间" width="150"> </el-table-column>
                <el-table-column
                    fixed="right"
                    align="center"
                    label="操作"
                    width="300"
                >
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="checkModelTeamIncomeUserRecord(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">查看</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant';
import { getUserById, getUserList } from '@/api/user';

export default {
    components: {
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetModelTeamIncomeUserRecordList();
                this.getModelTeamIncomeUserRecordList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetModelTeamIncomeUserRecordList();
                this.getModelTeamIncomeUserRecordList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            queryForm:{
                incomeId: '', //分红ID
                userId: '', //用户
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            modelTeamIncomeUserRecordState: 'add',
            modelTeamIncomeUserRecordStates: {
                add: '新建团队用户',
                check: '查看团队用户',
                edit: '修改团队用户'
            },
            USER_code: USER,
            USER_search: USER_SEARCH,
            multipleSelection: [],
            modelTeamIncomeUserRecordList: [],
            modelTeamIncomeUserRecord: {
                id: '', //
                leaderId: '',
                userId: '', //用户
            },
            btnLoading: false,
            srcList: [''],
            rules: {
                id: [{ required: true, message: '不能为空', trigger: 'blur' }],
                leaderId: [{ required: true, message: '领导ID不能为空', trigger: 'blur' }],
                userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
            }
        };
    },
    created() {
        // this.getModelTeamIncomeUserRecordList();
    },
    methods: {
        search(){
            this.isSearch = !this.isSearch;
        },
        updateSrcList(src){
            this.srcList[0] = src;
        },
        init(id){
            console.log(id)
            this.modelTeamIncomeUserRecord.leaderId = id;
            this.queryForm.leaderId = id;
            this.getModelTeamIncomeUserRecordList();
        },
        getValueUser(value) {
            this.modelTeamIncomeUserRecord.userId = value
        },
        getSearchValueUser(value){
            this.queryForm.userId = value
        },
        resetModelTeamIncomeUserRecordList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.modelTeamIncomeUserRecordList = [];
        },
        resetDialog() {
            this.modelTeamIncomeUserRecordState = 'add';
            this.showDialog = false;
            this.queryForm = {
                leaderId: this.queryForm.leaderId,
                userId: '', //用户
            };
            this.getModelTeamIncomeUserRecordList();
        },
        closeDialog() {
            this.showDialog = false
            this.modelTeamIncomeUserRecord = {
                id: '', //
                leaderId: this.modelTeamIncomeUserRecord.leaderId,
                userId: '', //用户
            };
        },
        addModelTeamIncomeUserRecord() {
            this.showDialog = true;
            this.modelTeamIncomeUserRecordState = 'add';
        },
        checkModelTeamIncomeUserRecord(modelTeamIncomeUserRecordId) {
            console.log(modelTeamIncomeUserRecordId);
            this.currentModelTeamIncomeUserRecordId = modelTeamIncomeUserRecordId;

            this.getModelTeamIncomeUserRecordById();
            this.showDialog = true;
            this.modelTeamIncomeUserRecordState = 'check';
        },
        editModelTeamIncomeUserRecord(modelTeamIncomeUserRecordId) {
            console.log('modelTeamIncomeUserRecord', modelTeamIncomeUserRecordId);
            if (modelTeamIncomeUserRecordId) {
                this.currentModelTeamIncomeUserRecordId = modelTeamIncomeUserRecordId;
                this.getModelTeamIncomeUserRecordById();
            } else {
                this.modelTeamIncomeUserRecord = { ...this.modelTeamIncomeUserRecord, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.modelTeamIncomeUserRecordState = 'edit';
        },
        deleteModelTeamIncomeUserRecord(modelTeamIncomeUserRecordId) {
            let ids = '';
            if (modelTeamIncomeUserRecordId) {
                ids = modelTeamIncomeUserRecordId;
            } else {
                ids = this.multipleSelection.map((modelTeamIncomeUserRecord) => modelTeamIncomeUserRecord.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/model/teamincomeuserrecord/delete`,{ ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetModelTeamIncomeUserRecordList();
                            this.getModelTeamIncomeUserRecordList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {});
        },
        refreshModelTeamIncomeUserRecordList() {
            this.resetModelTeamIncomeUserRecordList();
            this.getModelTeamIncomeUserRecordList();
        },
        getModelTeamIncomeUserRecordList(query = {}) {
            this.loading = true;
            getUserList({  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.modelTeamIncomeUserRecordList = res.page.list;
                    this.totalNum = res.page.total;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        getModelTeamIncomeUserRecordById() {
            getUserById({ id: this.currentModelTeamIncomeUserRecordId }).then((res) =>{
                if(res.success){
                    this.modelTeamIncomeUserRecord = { ...this.modelTeamIncomeUserRecord, ...res.mppUser };
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        /**
         * 导出信息
         */
        exportModelTeamIncomeUserRecordList() {
            //this.btnLoading = true;
            exprotExcel(`/model/teamincomeuserrecord/export`, {...this.queryForm});
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/model/teamincomeuserrecord/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params){
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/model/teamincomeuserrecord/importData`,formData);
            this.refreshModelTeamIncomeUserRecordList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getModelTeamIncomeUserRecordList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getModelTeamIncomeUserRecordList();
        }
    }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>